// extracted by mini-css-extract-plugin
export default {"selfAssessIconContainer":"selfAssessIconContainer-q3Tx6","actionsContent":"actionsContent-UeS2b","readonlyField":"readonlyField-CWfuY"};